// delta-05 — tradução gerada a partir de scripts/i18n/out/missing-es.json
const catalogo: Record<string, string> = {
    "%{arg1} campo(s) preenchido(s) com os dados da Receita": "%{arg1} campo(s) completado(s) con los datos de la Receita",
    "%{arg1} cobrança(s) cancelada(s)": "%{arg1} cobro(s) cancelado(s)",
    "%{arg1} registros foram atualizados": "%{arg1} registros fueron actualizados",
    "%{arg1}h": "%{arg1}h",
    "0.1em": "0.1em",
    "0.6rem": "0.6rem",
    "150px": "150px",
    "1px solid": "1px solid",
    "1px solid #f1f5f9": "1px solid #f1f5f9",
    "A roda comporta no máximo %{arg1} fatias.": "La rueda admite un máximo de %{arg1} porciones.",
    "Abaixo do estoque mínimo": "Por debajo del stock mínimo",
    "Abastecendo": "Cargando combustible",
    "Aberturas influenciadas": "Aperturas influenciadas",
    "Aguardando": "Esperando",
    "Aguardando sorteio": "Esperando sorteo",
    "Ativar pontuação": "Activar puntuación",
    "Ativo Sem Faturamento": "Activo sin facturación",
    "Atualiza a cada 15 segundos": "Se actualiza cada 15 segundos",
    "Atualizações em tempo real": "Actualizaciones en tiempo real",
    "Autorizado": "Autorizado",
    "Autorização Pendente": "Autorización pendiente",
    "Avaliação nas lojas": "Calificación en las tiendas",
    "Basear nos últimos %{arg1} dias": "Basarse en los últimos %{arg1} días",
    "Brinde virtual": "Premio virtual",
    "Buscando...": "Buscando...",
    "Buscar na Receita": "Buscar en la Receita",
    "CNPJ com situação \"%{arg1}\" na Receita": "CNPJ con situación \"%{arg1}\" en la Receita",
    "Cancelando...": "Cancelando...",
    "Cancelar Selecionadas": "Cancelar seleccionadas",
    "Clientes antigos": "Clientes antiguos",
    "Clientes contemplados": "Clientes contemplados",
    "Clientes novos": "Clientes nuevos",
    "Clientes únicos": "Clientes únicos",
    "Conferindo…": "Verificando…",
    "Conferir consistência (período)": "Verificar consistencia (período)",
    "Confirmadas pelo app": "Confirmadas por la aplicación",
    "Cor automática da rede — clique para escolher": "Color automático de la red — haga clic para elegir",
    "Custo parceiro (R$)": "Costo del socio (R$)",
    "Custo por giro (R$)": "Costo por giro (R$)",
    "Custo total (R$)": "Costo total (R$)",
    "Defina uma mensagem push": "Defina un mensaje push",
    "Defina uma mensagem sms": "Defina un mensaje sms",
    "Desativar pontuação": "Desactivar puntuación",
    "Desconto de combustível": "Descuento de combustible",
    "Durar pelos próximos %{arg1} dias": "Durar los próximos %{arg1} días",
    "Entregues": "Entregadas",
    "Erro ao %{arg1} revenda": "Error al %{arg1} revendedor",
    "Executando...": "Ejecutando...",
    "Executar Job SGA Agora": "Ejecutar Job SGA ahora",
    "Faturando": "Facturando",
    "Giro expirado": "Giro expirado",
    "Giro pendente": "Giro pendiente",
    "Giro realizado": "Giro realizado",
    "Giros expirados": "Giros expirados",
    "Giros pendentes": "Giros pendientes",
    "Giros premiados": "Giros premiados",
    "Influenciadas": "Influenciadas",
    "Informe o CNPJ completo": "Ingrese el CNPJ completo",
    "LIVE": "LIVE",
    "Litros abastecidos": "Litros cargados",
    "Nenhum fator de pontuação foi definido": "Ningún factor de puntuación fue definido",
    "Não foi dessa vez. Abasteça de novo e ganhe outro giro.": "No fue esta vez. Cargue combustible de nuevo y gane otro giro.",
    "Não sorteado": "No sorteado",
    "Número sorteado": "Número sorteado",
    "Números aguardando sorteio": "Números esperando sorteo",
    "Números da sorte concedidos": "Números de la suerte otorgados",
    "Números sorteados": "Números sorteados",
    "POLL": "POLL",
    "Palpite expirado": "Pronóstico expirado",
    "Palpite pendente": "Pronóstico pendiente",
    "Palpite realizado": "Pronóstico realizado",
    "Palpite vencedor": "Pronóstico ganador",
    "Palpites concedidos": "Pronósticos otorgados",
    "Palpites pendentes": "Pronósticos pendientes",
    "Palpites realizados": "Pronósticos realizados",
    "Palpites vencedores": "Pronósticos ganadores",
    "Para zerar a pontuação, selecione um grupo específico (etiqueta de clientes ou clientes).": "Para poner en cero la puntuación, seleccione un grupo específico (etiqueta de clientes o clientes).",
    "Pix expirados": "Pix expirados",
    "Ponto %{arg1}": "Punto %{arg1}",
    "Preenche razão social, inscrição estadual e endereço": "Completa razón social, inscripción estadual y dirección",
    "Primeiro envio": "Primer envío",
    "Prêmios sendo liberados": "Premios en liberación",
    "Receita Pix (R$)": "Ingresos Pix (R$)",
    "Recompensas emitidas": "Recompensas emitidas",
    "Recompensas estornadas": "Recompensas revertidas",
    "Recompensas expiradas": "Recompensas expiradas",
    "Recompensas pendentes": "Recompensas pendientes",
    "Recompensas utilizadas": "Recompensas utilizadas",
    "Reserva Pendente": "Reserva pendiente",
    "Reservado": "Reservado",
    "Revenda %{arg1} com sucesso": "Revendedor %{arg1} con éxito",
    "Selecionar arquivo": "Seleccionar archivo",
    "Selecione apenas cobranças pagas pelo cliente": "Seleccione solo cobros pagados por el cliente",
    "Selecione cobranças da mesma revenda para pagar": "Seleccione cobros del mismo revendedor para pagar",
    "Sem Tags": "Sin etiquetas",
    "Telefone não encontrado": "Teléfono no encontrado",
    "Tem certeza que deseja ativar esta pontuação?": "¿Está seguro de que desea activar esta puntuación?",
    "Tem certeza que deseja desativar esta pontuação?": "¿Está seguro de que desea desactivar esta puntuación?",
    "Total %{arg1}": "Total %{arg1}",
    "Trocar a cor da fatia": "Cambiar el color de la porción",
    "Trocar arquivo": "Cambiar archivo",
    "Valor abastecido (R$)": "Valor cargado (R$)",
    "Você ganhou outro giro! Gire de novo.": "¡Ganó otro giro! Gire de nuevo.",
    "aparelhos alcançados": "dispositivos alcanzados",
    "cover": "cover",
    "credentials.host": "credentials.host",
    "da Receita": "de la Receita",
    "do cadastro": "del registro",
    "green": "green",
    "mediana": "mediana",
    "o aplicativo avisou que recebeu — não é taxa de entrega": "la aplicación avisó que la recibió — no es tasa de entrega",
    "o cliente tocou na notificação": "el cliente tocó la notificación",
    "p10": "p10",
    "p90": "p90",
    "pessimistic": "pessimistic",
    "recebeu, não tocou, e abriu o app em até 24 horas": "recibió, no tocó, y abrió la aplicación dentro de 24 horas",
    "rgba(250, 152, 127, 0.22)": "rgba(250, 152, 127, 0.22)",
    "rgba(250, 227, 142, 0.15)": "rgba(250, 227, 142, 0.15)",
    "rgba(250, 227, 142, 0.18)": "rgba(250, 227, 142, 0.18)",
    "saíram para os aparelhos da rede": "salieron hacia los dispositivos de la red",
    "tocou e caiu na tela que a mensagem prometia": "tocó y llegó a la pantalla que el mensaje prometía",
    "topo varejo": "tope minorista",
    "url(#roleta-preview-center)": "url(#roleta-preview-center)",
    "vezes que saiu": "veces que salió",
    "voltou ao app sem tocar": "volvió a la aplicación sin tocar",
    "Último envio": "Último envío",
};

export default catalogo;
